var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconSort = function SvgIconSort(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    fillRule: "evenodd",
    d: "M5.602 10.856a.438.438 0 0 0-.31-.747H3.98v-8.75a.437.437 0 0 0-.437-.437h-.875a.438.438 0 0 0-.438.437v8.75H.918a.438.438 0 0 0-.309.747l2.187 2.188c.17.171.448.171.618 0l2.188-2.188zm1.441-8.184h7a.438.438 0 0 0 .437-.438v-.875a.437.437 0 0 0-.437-.437h-7a.438.438 0 0 0-.438.437v.875c0 .242.196.438.438.438zm-.438 3.062c0 .242.196.438.438.438h5.25a.438.438 0 0 0 .437-.438v-.875a.437.437 0 0 0-.437-.437h-5.25a.438.438 0 0 0-.438.437v.875zm0 7c0 .242.196.438.438.438h1.75a.438.438 0 0 0 .437-.438v-.875a.437.437 0 0 0-.437-.437h-1.75a.438.438 0 0 0-.438.437v.875zm0-3.5c0 .242.196.438.438.438h3.5a.438.438 0 0 0 .437-.438v-.875a.437.437 0 0 0-.437-.437h-3.5a.438.438 0 0 0-.438.437v.875z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSort, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-sort.0749c175.svg";
export { ForwardRef as ReactComponent };